import React from "react";

const FALLBACK = "https://images.pexels.com/photos/6927546/pexels-photo-6927546.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

// Tries the given src, then falls back to a YouTube alt-thumb (for /vi/ID/* paths) and finally a curated image.
export default function SafeImage({ src, alt = "", className = "", fallback = FALLBACK, ...rest }) {
  const [stage, setStage] = React.useState(0);

  const computeSrc = () => {
    if (!src) return fallback;
    if (stage === 0) return src;
    // YouTube thumbnail fallbacks
    const ytMatch = src.match(/\/vi\/([^/]+)\/[^?]+/);
    if (ytMatch) {
      const id = ytMatch[1];
      if (stage === 1) return `https://i.ytimg.com/vi/${id}/mqdefault.jpg`;
      if (stage === 2) return `https://i.ytimg.com/vi/${id}/0.jpg`;
    }
    return fallback;
  };

  return (
    <img
      src={computeSrc()}
      alt={alt}
      className={className}
      onError={() => setStage((s) => (s < 3 ? s + 1 : s))}
      {...rest}
    />
  );
}
